import {
  DeliveryOptions,
  Festival,
  Invoice,
  Lodge,
  Package,
  Product,
} from '@shared';

export interface Reservation {
  id?: number;
  type: ReservationTypeTypes;
  subtype: ReservationSubtypeTypes;
  status: ReservationStatusTypes;
  customer_id: number;
  festival_id: number;
  lodge_id?: number;
  day_id?: number;
  selected_date?: string;
  pickup_time?: string;
  persons?: number;
  extra_persons: number;
  default_products?: Product[];
  default_packages?: Package[];
  extra_products?: Product[];
  extra_packages?: Package[];
  delivery?: DeliveryOptions;
  reservation_name?: string;
  custom_table_desc?: string;
  referer?: ReservationRefererTypes;
  notes?: string;
  email_content?: string;
  reference?: string;
  created_at?: string;
  updated_at?: string;
  picked_up?: boolean;
  festival?: Festival;
  invoices?: Invoice[];
  lodge?: Lodge;
}

export type ReservationTypeTypes =
  | 'frontend'
  | 'manual'
  | 'employee'
  | 'local'
  | 'club'
  | 'boss'
  | 'other';
export const ReservationTypeTypesMapper: Record<ReservationTypeTypes, string> =
  {
    frontend: 'Kunde',
    manual: 'Büro',
    employee: 'Mitarbeiter',
    local: 'Vor Ort',
    club: 'Verein',
    boss: 'Chef',
    other: 'Anderes',
  };

export type ReservationSubtypeTypes = 'default' | 'voucher' | 'mark' | 'nocalc';
export const ReservationSubtypeTypesMapper: Record<
  ReservationSubtypeTypes,
  string
> = {
  default: 'Rechnung',
  voucher: 'Gesamtwertscheck',
  mark: 'Markenverkauf',
  nocalc: 'Ohne Berechnung',
};

export type ReservationStatusTypes =
  | 'untouched'
  | 'tableopen'
  | 'processed'
  | 'payed'
  | 'deliveryprep'
  | 'sent'
  | 'done'
  | 'cancelled'
  | 'archived';
export const ReservationStatusTypesMapper: Record<
  ReservationStatusTypes,
  string
> = {
  untouched: 'Offen',
  tableopen: 'Tisch offen',
  processed: 'Bearbeitet',
  payed: 'Bezahlt',
  deliveryprep: 'Versand vorbereitet',
  sent: 'Verschickt',
  done: 'Abgeschlossen',
  cancelled: 'Storniert',
  archived: 'Archiviert',
};

export const statusDisableArray = [
  'cancelled',
  'archived',
  'payed',
  'sent',
  'done',
];

export type ReservationRefererTypes =
  | 'customer'
  | 'google'
  | 'facebook'
  | 'instagram'
  | 'ads'
  | 'recommendation'
  | 'event'
  | 'other';
export const ReservationRefererTypesMapper: Record<
  ReservationRefererTypes,
  string
> = {
  customer: 'BENZ & CO. Bestandskunde',
  google: 'Google',
  facebook: 'Facebook',
  instagram: 'Instagram',
  ads: 'Werbeanzeige',
  recommendation: 'Empfehlung',
  event: 'Veranstaltung',
  other: 'Sonstiges',
};

export interface ReservationSearchParams {
  festivalId?: number;
  lodgeId?: number;
  status?: ReservationStatusTypes;
  date?: string;
  sort?: string;
  order?: 'asc' | 'desc';
  type?: string;
  created_range_days?: Date[];
}
